<template>
  <div class="news">
    <En_topper></En_topper>
    <div class="nei_tit">
      <img src="../assets/news_tit.jpg"
           alt="" />
      <span>ENN News</span>
    </div>
    <div class="news_title">{{ detail.creationTitle }}</div>
    <div class="news_info">
      Release date:{{ detail.createTime }} | Source：{{ detail.creationAuthor }}
    </div>
    <div class="news_con"
         v-html="detail.contentName" />
    <En_footer></En_footer>
  </div>
</template>

<script>
import En_topper from "./En_topper";
import En_footer from "./En_footer";
export default {
  components: {
    En_topper,
    En_footer
  },
  name: "",
  data () {
    return {
      detail: {}
    };
  },
  watch: {
    $route (to, from) {
      if (to.query.id !== from.query.id) {
        let id = to.query.id;
        if (!id) {
          window.location.href = "/404.html";
          return;
        }
        this.$http
          .get("/news/details/" + id + ".json")
          .then(response => {
            this.detail = response.data;
            this.init();
            // 加文章点击数
            this.$http
              .get("/api/busArticle/updateHits?id=" + this.detail.id)
              .then(() => {
                console.log("success");
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
            window.location.href = "/404.html";
          });
      }
    }
  },
  methods: {
    init () {
      if (
        localStorage.getItem("typeface") &&
        localStorage.getItem("typeface") === "繁体"
      ) {
        this.langType = "t";
        // eslint-disable-next-line no-undef
        zh_tran("t");
        this.$nextTick(() => {
          this.langType = "t";
          // eslint-disable-next-line no-undef
          zh_tran("t");
        });
      } else {
        this.langType = "s";
        // eslint-disable-next-line no-undef
        zh_tran("s");
        this.$nextTick(() => {
          this.langType = "s";
          // eslint-disable-next-line no-undef
          zh_tran("s");
        });
      }
    }
  },
  mounted () {
    let maodian = this.$route.params.maodian;
    console.log(maodian);
    if (maodian) {
      const targetElement = document.querySelector(maodian);
      window.scrollTo({ top: targetElement.offsetTop, behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
    let id = this.$route.query.id;
    // 没有id时，跳转到404页面
    if (!id) {
      window.location.href = "/404.html";
      return;
    }
    this.$http
      .get("/news/endetails/" + id + ".json")
      .then(response => {
        this.detail = response.data;
        this.init();
        // 加文章点击数
        this.$http
          .get("/api/busArticle/updateHits?id=" + this.detail.id)
          .then(() => {
            console.log("success");
          })
          .catch(error => {
            console.log(error);
          });
      })
      .catch(error => {
        console.log(error);
        window.location.href = "/404.html";
      });
  }
};
</script>

<style scoped>
.news {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
.news_title {
  width: 690px;
  padding: 30px 30px 20px 30px;
  text-align: center;
  font-size: 36px;
  color: #000;
  font-weight: 600;
}
.news_info {
  width: 750px;
  height: 50px;
  background: #fff;
  text-align: center;
  font-size: 20px;
  color: #666;
  line-height: 50px;
  border-bottom: 3px solid #f1f2f6;
}
</style>
<style>
.news_con {
  font-size: 28px;
  line-height: 180%;
  color: #1d2129;
  padding: 30px;
  width: 690px;
}
.news_con img {
  width: 690px;
  margin: 20px 0 0 0;
  border-radius: 5px;
}
.news_con video {
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 20px 0 0 0;
  border-radius: 5px;
}
.news_con p {
  padding: 10px 0;
  display: block;
  /* text-indent: 2em; */
  text-align: left;
}
.news_con .imginfo {
  display: block;
  width: 100%;
  margin: 0;
  height: auto;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #999;
}
.news_con h6 {
  width: 100%;
  text-align: left;
  font-size: 32px;
  font-weight: bold;
}
</style>
